import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('@/views/exemption/List.vue')
const Edit = () => import('@/views/exemption/Edit.vue')

const listRoute: RouteConfig = {
  path: '/exemption-list',
  name: 'exemption_list',
  component: List,
  meta: {
    title: '免修记录',
  },
}

const editRoute: RouteConfig = {
  path: '/exemption-edit',
  name: 'exemption_edit',
  component: Edit,
  meta: {
    title: '设置免修时间',
  },
}

export default [listRoute, editRoute]

export function navigateToExemptionList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToExemptionEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}
